module.exports = __webpack_public_path__ + "static/media/angle-double-next.486d605e.svg";